import { Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { useEffect, useState } from "react";

export const TextFieldSearch = ({ search, setOpen, label, error, notEditable, from }) => {
const hasValue = Boolean(search);

  return (
    <>
      <Box
        // disabled
        // size="small"
        readonly
        fullWidth
        onClick={() => {
          // setSearchOutStandingsModal(true)
        }}
        // id="name"
        // label="Search by Name/Mobile Number"
        // value={search}
        sx={{
          position: "relative",
          display: "flex",
          height: from ? "15px" : "23px",
          justifyContent: "space-between",
          // width: "70%",
          border:
            from === "previousBilling"
              ? "2px solid #01008B"
              : "1px solid #01008B",
          p: 2,
          borderRadius: "4px ",
          color: "grey",
          "&:hover": {
            cursor: "pointer !important",
          },
        }}
        onChange={(e) => {
          // setSearch(e.target.value);
        }}
      >
        <Typography
          sx={{
            position: "absolute",
            top: hasValue ? "-8px" : "50%",
            left: "12px",
            transform: hasValue ? "scale(0.85)" : "translateY(-50%)",
            background: "#fff",
            px: "4px",
            color: "#555",
            fontSize: hasValue ? "14px" : "15px",
            transition: "all 0.2s ease",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="p"
          fontWeight={400}
          sx={{
            fontSize: { xs: "12px", sm: "12px", md: "15px" },
          }}
          color={"#000"}
        >
          {/* {((search !== "") )?label:"Search by Name/Mobile Number"} */}
          {search ? search : label}
        </Typography>
        {!notEditable && (
          <PersonSearchIcon
            onClick={() => {
              // setSearchModal(true)
              if (!notEditable) {
                setOpen(true);
              }
            }}
            sx={{
              color: (theme) => theme.palette.primary.main,
              cursor: "pointer",
            }}
          />
        )}
      </Box>
      {error && (
        <Typography
          variant="body2"
          color="error"
          sx={{
            mt: 0.5,
            fontSize: "12px",
          }}
        >
          Please enter a valid search term.
        </Typography>
      )}
    </>
  );
}